import React from 'react';
import Section from '../UI/Section/Section';
import { GridItem, GridReveal } from '../UI/Grid/Grid';
import Type from '../UI/Type/Type';
import Teaser from '../UI/Teaser/Teaser';
import Video from '../UI/Video/Video';
import HtmlContent from '../UI/HtmlContent/HtmlContent';

const VideoBlock = ({
  teaser,
  heading,
  body,
  video,
  ...other
}) => {
  return (
    <Section {...other}>
      <GridReveal staggerChildren={true}>
        <GridItem lg={4}>
          <Teaser>{teaser}</Teaser>
          <Type.H2>{heading}</Type.H2>
          <HtmlContent content={body}/>
        </GridItem>
        <GridItem lg={8}>
          <Video url={video}/>
        </GridItem>
      </GridReveal>
    </Section>
  );
};

export default VideoBlock;
